var bundledVariants = [];
var groupsellbundledVariants = [];
var discountCodes = [];

const urlParams = new URLSearchParams(window.location.search);
const note = urlParams.get("note");
const ATID = urlParams.get("ATID");

$(document).ready(function () {
  checkBundledVariants();
  checkGroupsellVariants();
  handleAirconBundleOnChange();
});
// For Prism Neo
$(".dropdown-color-selector .colorbox-select").click(function () {
  checkBundledVariants();
  handleAirconBundleOnChange();
});
// Get bundled products on variant change to reduce impact on checkout speed.
$("#SingleOptionSelector-0").change(function () {
  //console.log("option changed");
  checkBundledVariants();
});
// for new product page item selection update

$(".upsellProductsContainer.upsellProducts").click(function () {
  setTimeout(function () {
    checkBundledVariants();
  }, 50);
});
function checkGroupsellVariants() {
  groupsellbundledVariants = [];

  const $pb = $("#ProdBundle");
  if (!$pb.length) return;

  const raw = $pb.attr("data-gp2-bundled-ids");
  if (!raw) return;

  raw.split(",").forEach((val) => {
    val = val.trim();
    if (val && val !== "0") groupsellbundledVariants.push(val);
  });

  //console.log("✔ groupsellbundledVariants:", groupsellbundledVariants);
}

function checkBundledVariants() {
  bundledVariants = []; // Reset bundled variants
  var variantTitle = $("#SingleOptionSelector-0").val();

  var Groupsell2variantId = $("#ProdBundle").attr("data-gp2-id");

  if ($(".zero-aircon-only #AirconSystemSelect-product-template").length) {
    //var selectval = $("#AirconSystemSelect-product-template").val();
    var selectval = $(
      '.form-selected input[name="aircon_select"]:checked',
    ).val();
    if (selectval == "System-1") {
      var variantId = $(
        ".form-selected .ProductSelect-product-template.system-1",
      ).val();
    } else if (selectval == "System-2") {
      var variantId = $(
        ".form-selected .ProductSelect-product-template.system-2",
      ).val();
    } else if (selectval == "System-3") {
      var variantId = $(
        ".form-selected .ProductSelect-product-template.system-3",
      ).val();
    } else if (selectval == "System-4") {
      var variantId = $(
        ".form-selected .ProductSelect-product-template.system-4",
      ).val();
    }
  } else if ($("#currentSelection").length) {
    var variantId = $("#currentSelection").attr("data-variant");
    //console.log("sel" + variantId);
  } else if (variantTitle) {
    var variantId = $(
      '#ProductSelect-product-template option:contains("' + variantTitle + '")',
    ).attr("value");
  } else {
    if (Groupsell2variantId != "") {
      var variantId = Groupsell2variantId;
    } else {
      var variantId = $("#ProductSelect-product-template").val();
    }
  }

  var $option = $(
    '.ProductSelect-product-template option[value="' + variantId + '"]',
  );
  //console.log("selected" + variantId);
  // Check if bundled
  if ($option.attr("data-bundled-variant-ids")) {
    var bundledVariantIds = $option.attr("data-bundled-variant-ids").split(",");
    //console.log(bundledVariantIds);
    // Updated bundled variants array
    $.each(bundledVariantIds, function (key, val) {
      if (val && val !== "0") bundledVariants.push(val);
    });
  }
}

function syncAutoBundleToLegacyArray() {
  /* this function adds the bundled ids if found. on selectors, ensure that currentSelection will have the bundled-variant-ids */
  const autoIds = $("#currentSelection").attr("data-bundled-variant-ids");
  if (autoIds) {
    const ids = autoIds
      .split(",")
      .map((id) => id.trim())
      .filter(Boolean);
    // Update bundledVariants to include new handler bundle IDs
    bundledVariants = [...new Set([...bundledVariants, ...ids])];
    //console.log("🟢 Synced auto-bundle IDs:", bundledVariants);
  } else {
    //console.log("⚠️ No auto-bundle IDs found on #currentSelection");
  }
}

async function getCartData() {
  const cart = await fetch("/cart.js");
  const data = await cart.json();
  return data;
}

function getLargestSystem(cartData, currentSystem) {
  const currentSystemNum = parseInt(
    currentSystem.match(/System-(\d+)/)?.[1] || 0,
    10,
  );

  const allAirconds = cartData.items.filter(
    (item) =>
      item.product_id === 8841655419107 || item.product_id === 8846508818659,
  );

  const largestInCart = allAirconds
    .map((item) => {
      const match = item.title.match(/System (\d+)/);
      return match ? parseInt(match[1], 10) : null;
    })
    .filter((num) => num !== null)
    .reduce((max, current) => Math.max(max, current), 0);

  const largestSystemNum = Math.max(currentSystemNum, largestInCart);

  return `System-${largestSystemNum}`;
}

/* ==================== 
MAIN ADD TO CART BUTTON
======================= */
$("#AddToCart-button").click(async function (event) {
  //console.log("🟢 AddToCart CLICK HANDLER STARTED");
  event.preventDefault();

  let itemsToAdd = [];

  checkBundledVariants();
  checkGroupsellVariants();
  syncAutoBundleToLegacyArray();

  var groupsellBundleID = Date.now();

  // const isAPPDP = $("#shopify-section-product-template-aura").length > 0;
  // if (isAPPDP) {
  //   await handleAPAddons();
  //   location.href = "/cart";
  //   return;
  // }
  /* ============================
    Add Selected Accessories
  ============================= */

  const isDoors = $("#product-doors-8851863929059").length > 0;
  if (isDoors) {
    
    await handleDoorsPDP();
    location.href = "/cart";
    return;
  }

  const isGates = $("#product-gates-8855634280675").length > 0;
  if (isGates) {
    await handleGatesPDP();
    location.href = "/cart";
    return;
  }

  const isDoorGateBundle = $("#product-door-gate-8890655932643").length > 0;
  if (isDoorGateBundle) {
    try {
      await handleDoorGateBundle();
      location.href = "/cart";
    } catch (error) {
      console.error(error);
      alert(
        "To complete your order, make sure you’ve included all the required selections before checking out.",
      );
      handleDoorGateBundleError();
    }
    return;
  }

  if ($(".sealsubs-target-element .sealsubs-container").length) {
    try {
      const formData = {
        items: [
          {
            id: $("#currentSelection").attr("data-variant"),
            quantity: 1,
            selling_plan: $(`.sealsubs-target-element [name="selling_plan"]`).val(),
          }
        ],
      };

      console.log(formData);

      const xhr = new XMLHttpRequest();
      xhr.open('POST', '/cart/add.js');
      xhr.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');

      xhr.onload = function () {
        location.href = "/cart";
      };

      xhr.send(JSON.stringify(formData));
    } catch (error) {
      console.error(error);
    }

    return;
  }

  if (
    bundledVariants.length <= 0 &&
    groupsellbundledVariants.length <= 0 &&
    !$(".form-selected #AirconSystemSelect-product-template").length &&
    !$(".selected_variantId").length &&
    !$("#currentSelection").attr("data-variants")
  ) {
    window.location.href = $(this).attr("href");
    return;

    // if ($("#ProdBundle").attr("data-vid")) {
    //   await handlePdpWithAddon();
    //   location.href = "/cart";
    //   return;
    // }
  }
  
  let solaris_bundle_temp_fix_bundleId = Date.now();

  if ($(".selected_variantId").length > 0) {
    const selectedVariantIds = $(".selected_variantId");
    let variantIds = "";
    selectedVariantIds.each((_, x) => {
      const text = $(x).text();
      if (text.trim() != "") {
        variantIds += `,${text}`;
      }
    });

    let solaris_bundle_temp_fix_properties = {
      "Bundle ID": `solaris_bundle-${solaris_bundle_temp_fix_bundleId}`
    };

    if (variantIds.trim() != "") {
      variantIds.split(",").forEach((x) => {
        if (x.trim() == "") return;
        let item = {
          id: x,
          quantity: 1,
          properties: {},
        };
        if (x.includes("-")) {
          item.id = x.split("-")[0];
          item.quantity = x.split("-")[1];
        }

        if (location.pathname.indexOf("prism-solaris") > -1 && ["47880184594659","47880191115491","47880191148259","47880191181027"].includes(item.id)) {
          item.properties = solaris_bundle_temp_fix_properties;
        }

        itemsToAdd.push(item);
      });
      /*
        THIS SHOULD NOT POST TO CART IMMEDIATELY, there is the function at the end , just have to add/push to cart first
        var params = {
          type: "POST",
          url: "/cart/add.js",
          data: { items: itemsToAdd },
          dataType: "json",
          success: function (line_item) {
            cartTotal();
            window.location.href = "/cart";
          },
          error: function (XMLHttpRequest, textStatus) {
            //console.log("test 5.");
            //window.location.reload();
            console.log("Error adding to cart");
            console.log(XMLHttpRequest);
            console.log(textStatus);
          },
        };
        $.ajax(params);
        return;
        */
    }
  }

  var productTitle = $(".product-single__title").text();
  if ($(".zero-aircon-only #AirconSystemSelect-product-template").length) {
    //var selectval = $("#AirconSystemSelect-product-template").val();
    var selectval = $(
      '.form-selected input[name="aircon_select"]:checked',
    ).val();
    if (selectval == "System-1") {
      var variantId = $(
        ".form-selected .ProductSelect-product-template.system-1",
      ).val();
    } else if (selectval == "System-2") {
      var variantId = $(
        ".form-selected .ProductSelect-product-template.system-2",
      ).val();
    } else if (selectval == "System-3") {
      var variantId = $(
        ".form-selected .ProductSelect-product-template.system-3",
      ).val();
    } else if (selectval == "System-4") {
      var variantId = $(
        ".form-selected .ProductSelect-product-template.system-4",
      ).val();
    }
  } else if ($("#currentSelection").length) {
    var variantId = $("#currentSelection").attr("data-variant");
    //console.log("sel" + variantId);
  } else {
    var variantId = $(
      "#ProductSelect-product-template.product-form__variants2",
    ).val();
  }
  var variantProperties = $("#currentSelection").attr("data-properties");

  if (variantId == "") {
    alert("Please select the system combination.");
    //$(".syscombi").addClass("active");
    //$("#AirconSystem-Display").addClass("empty");
    //$(".AirconSystem-select").toggleClass("active");
    return false;
  }

  var variantTitle = $(
    '.ProductSelect-product-template option[value="' + variantId + '"]',
  ).data("title");
  var variantPrice = $(
    '.ProductSelect-product-template option[value="' + variantId + '"]',
  )
    .data("price")
    ?.toString()
    .replace(/,(?=\d{3})/g, "");
  var prodQuantity = $("#currentSelection").attr("data-quantity") || "1";
  var Groupsell = $(".selectedgroupsell").text();
  //console.log("Veera");
  // Sentenl and sentry indivual products
  const key = variantId + "-" + Groupsell;

  if (
    ($("#prism-sentinel-8662946513123").length ||
      $("#prism-sentry-8662946742499").length) &&
    Groupsell != "" &&
    lockBundleVariantsId[variantId + "-" + Groupsell] != undefined
  ) {
    /*console.log(
      "lockbundle variants " +
        lockBundleVariantsId[variantId + "-" + Groupsell],
    );*/
    variantId = lockBundleVariantsId[variantId + "-" + Groupsell];
    //console.log(lockBundle[variantId]);
    var bundledVariantIds = lockBundle[variantId].split(",");
    //console.log(bundledVariantIds);
    // Updated bundled variants array
    bundledVariants = [];
    $.each(bundledVariantIds, function (key, val) {
      if (val && val !== "0") bundledVariants.push(val);
    });
    Groupsell = "";
    var productTitle = lockBundleProdudctTitle;
  }

  var Groupsell2variantId = $("#ProdBundle").attr("data-gp2-id");
  var Groupsell2variantTitle = $("#ProdBundle").attr("data-vtitle");

  /* Auto Bundled groupsell proudct and its bundled products
  to display data properties in cart */
  const $wrap = $(".auto-bundle-variants");

  // ✅ Find selected .newsalebox2 within this wrapper
  const $selectedBox = $wrap.find(".newsalebox2.selected");

  // ✅ Default values
  let selectedTitle = "";
  let selectedPrice = "";

  // ✅ Extract title and price
  if ($selectedBox.length) {
    selectedTitle = $.trim($selectedBox.find(".prodName2").text()) || "";

    const priceText =
      $.trim($selectedBox.find(".prodprice2 .newprice").text()) || "";
    if (priceText) {
      selectedPrice = priceText.replace(/\s+/g, ""); // Keep "$99" format
    }
  }

  // ✅ Build display output (title + parentheses if price exists)
  let displayOutput = selectedTitle;
  if (selectedPrice && selectedPrice !== "$0" && selectedPrice !== "0") {
    displayOutput += ` ($${selectedPrice.replace("$", "")})`;
  }

  /* end of selected props */

  if (variantProperties) {
    var mainProduct = {
      quantity: prodQuantity,
      id: variantId,
      properties: {
        Remarks: variantProperties,
      },
    };
  } else {
    var mainProduct = {
      quantity: prodQuantity,
      id: variantId,
      properties: {
        "Selected Set": displayOutput,
      },
    };
  }
  if (Groupsell2variantId != undefined) {
    var GroupsellmainProduct = {
      quantity: prodQuantity,
      id: Groupsell2variantId,
      properties: {},
    };

  }

  const acBundle = $("[name='aircon_bundle_select']:checked");
  if (acBundle.length) {
    mainProduct.properties["_acBundle"] =
      acBundle.val().split("-")[1] || acBundle.val();
  }

  // Pre-order properties
  if ($("#preorderProperty").length) {
    var preorderProperty = $("#preorderProperty").val();
    mainProduct.properties[preorderProperty] = 1;
  }
  //console.log(bundledVariants);
  // Bundled product
  if (bundledVariants.length > 0) {
    var bundleId = Date.now();

    //CF instalation / warranty sku
    
    if (
      $("#prism-oasis-pro-8662936355043").length > 0 ||
      $("#prism-oasis-8662929572067").length > 0 ||
      $("#prism-oasis-pro-macaron-8837866651875").length > 0
    ) {
      bundledVariants.push("49516169298147");
    }
    

    mainProduct.properties["Bundle ID"] = bundleId;
    if (note) {
      mainProduct.properties["note"] = note;
    }
    if (ATID) {
      mainProduct.properties["ATID"] = ATID;
    }

    var bundleProduct = {
      quantity: prodQuantity,
      id: null,
      properties: {
        "Bundle ID": bundleId, // for Grouping
        "Bundled with": productTitle, // for identifying bundled product
      },
    };
    //console.log(productTitle);
    if (Groupsell != "") {
      var GroupsellProduct = {
        quantity: prodQuantity,
        id: Groupsell,
        properties: {},
      };
      itemsToAdd.push(mainProduct, GroupsellProduct);
    } else {
      itemsToAdd.push(mainProduct);
    }

    $.each(bundledVariants, function (key, val) {
      var product = { ...bundleProduct };
      product.id = val;

      var bundle_data = val.split("-");
      product.id = bundle_data[0];
      if (bundle_data[1]) {
        product.quantity = bundle_data[1];
      }

      if (location.pathname.indexOf("prism-solaris") > -1 && ["47880218575075","47880219394275","47880223719651","48315547910371","47880218607843"].includes(product.id)) {
        product.properties["Bundle ID"] = `solaris_bundle-${solaris_bundle_temp_fix_bundleId}`;
      }

      itemsToAdd.unshift(product);
    });
  } else {
    itemsToAdd.push(mainProduct);
  }

  // Ensure itemsToAdd exists before groupsell child bundle block
  if (typeof itemsToAdd === "undefined" || itemsToAdd.length == 0) {
    itemsToAdd = [mainProduct];
  }

  if (groupsellbundledVariants.length > 0) {
    const now = new Date();
    const minutesToAdd = 30;
    now.setMinutes(now.getMinutes() + minutesToAdd);
    const timestamp = now.getTime();
    //console.log(timestamp);
    var bundleId2 = Date.now();
    //var currentDate = parseInt(555) + parseInt(bundleId2);

    var groupbundleProduct = {
      quantity: prodQuantity,
      id: null,
      properties: {
        "Bundle ID": groupsellBundleID, // for Grouping
        "Bundled with": Groupsell2variantTitle, // for identifying bundled product
      },
    };

    $.each(groupsellbundledVariants, function (key, val) {
      var product2 = { ...groupbundleProduct };
      product2.id = val;

      var bundle_data2 = val.split("-");
      product2.id = bundle_data2[0];
      if (bundle_data2[1]) {
        product2.quantity = bundle_data2[1];
      }

      itemsToAdd.unshift(product2);
    });
  }

  var contentName = `${productTitle}`;
  if (variantTitle !== "Default Title") contentName += ` - ${variantTitle}`;

  // FB Pixel
  var fbqObj = {
    content_name: contentName,
    content_category: meta.product.type,
    content_ids: [meta.product.id],
    content_type: "product_group",
    value: variantPrice,
    num_items: prodQuantity,
    currency: "SGD",
  };
  //console.log(fbqObj);
  //console.log(fbq)
  if (typeof fbq !== "undefined" && fbq) fbq("track", "AddToCart", fbqObj);
  fbq = null;

  //TikTok Pixel

  var pri = variantPrice?.replace(/\,/g, ""); // 1125, but a string, so convert it to number
  pri = parseInt(pri, 10);

  var ttqObj = {
    content_name: contentName,
    content_category: meta.product.type,
    content_id: meta.product.id,
    content_type: "product_group",
    value: pri,
    quantity: prodQuantity,
    currency: "SGD",
  };
  if (ttq) ttq.track("AddToCart", ttqObj);
  /*
  /* When second groupsell is added, somehow the quantity added is 2.. 
  i commented this out and still the second groupsell is being added.. 
  so for now maybe we can comment this out 
    if ($(".selectedgroupsell-second").length == 1) {
      const groupsell_second = $(".selectedgroupsell-second").text();
      if (groupsell_second && groupsell_second != "") {
        itemsToAdd.push({
          id: groupsell_second,
          quantity: 1,
          properties: {},
        });
      }
  }*/
  /* groupsell fix for dryers since they are not being added together if 2 groupsell items selected */
  if (
    location.pathname.indexOf("/prism-cyclone-dryer") > -1 ||
    location.pathname.indexOf("/prism-monsoon-dryer") > -1
  ) {
    if ($(".selectedgroupsell").length == 1) {
      const groupsell_fix = $(".selectedgroupsell").text();
      if (groupsell_fix && groupsell_fix != "") {
        itemsToAdd.push({
          id: groupsell_fix,
          quantity: 1,
          properties: {},
        });
      }
    }
  }

  /* commented out, since 2 items are added to cart for fridge warranties.. need to check after editing this out */
  if (
    $(".selected_variantId").length == 1 &&
    $(".groupsell-wrap").length == 0
  ) {
    const warrantyAddOn = $(".selected_variantId").text();
    if (warrantyAddOn.trim() != "") {
      warrantyAddOn.split(",").forEach((x) => {
        if (x.includes("-")) {
          itemsToAdd.push({
            id: x.split("-")[0],
            quantity: x.split("-")[1],
            properties: {},
          });
        } else {
          itemsToAdd.push({
            id: x,
            quantity: 1,
            properties: {},
          });
        }
      });
    }
  }

  var Groupsell2variantId = $("#ProdBundle").attr("data-gp2-id");

  // Ensure itemsToAdd exists before groupsell child bundle block
  if (typeof itemsToAdd === "undefined") {
    itemsToAdd = [mainProduct];
  }
  if (groupsellbundledVariants.length > 0) {
    if (Groupsell2variantId != undefined) {
      if (Groupsell2variantId != "") {
        itemsToAdd.push({
          id: Groupsell2variantId,
          quantity: prodQuantity,
          properties: {
            "Bundle ID": groupsellBundleID,
          },
        });
      }
    }
  } else {
    if (Groupsell2variantId != undefined) {
      if (Groupsell2variantId != "") {
        itemsToAdd.push({
          id: Groupsell2variantId,
          quantity: prodQuantity,
          properties: {},
        });
      }
    }
  }

  const $current = $("#currentSelection");
  const variantsRaw = $current.attr("data-variants");
  //console.log("selected variants:" + variantsRaw);
  if (variantsRaw) {
    //console.log("variants added");
    variantsRaw.split(",").forEach(function (variantId) {
      variantId = variantId.trim();
      if (!variantId) return;

      itemsToAdd.push({
        id: variantId,
        quantity: 1,
        properties: {},
      });
    });
  } else {
    //console.log("no variants to add");
  }

  //console.log("🛒 itemsToAdd after variants:", JSON.stringify(itemsToAdd));

  // switch Sentinel Copper Rose to Sentinel Pro Copper Rose
  const idMap = {
    // Standard
    45530305757411: "48554691854563", // Sentry Space Grey
    45530305855715: "48554691952867", // Sentry Copper Rose
    45530305954019: "48554692051171", // Sentry Nickel Silver
    45530306052323: "48554692149475", // Sentry Pro Space Grey
    45530306150627: "48554692247779", // Sentry Pro Copper Rose
    45530306248931: "48554692346083", // Sentry Pro Nickel Silver
    // Saver
    45775797715171: "48554692444387", // Sentry Space Grey
    45775799648483: "48554692542691", // Sentry Copper Rose
    45775805055203: "48554692640995", // Sentry Nickel Silver
    45775805350115: "48554692739299", // Sentry Pro Space Grey
    45775806464227: "48554692837603", // Sentry Pro Copper Rose
    45775808954595: "48554692935907", // Sentry Pro Nickel Silver
  };
  itemsToAdd = itemsToAdd.map((item) =>
    idMap[item.id] ? { ...item, id: idMap[item.id] } : item,
  );

  // Post to cart
  var params = {
    type: "POST",
    url: "/cart/add.js",
    data: { items: itemsToAdd },
    dataType: "json",
    success: function (line_item) {
      cartTotal();
      window.location.href = "/cart";
    },
    error: function (XMLHttpRequest, textStatus) {
      //console.log("test 5.");
      //window.location.reload();
      //console.log("Error adding to cart");
      //console.log(XMLHttpRequest);
      //console.log(textStatus);
    },
  };
  $.ajax(params);
});

/* ============================================
MAIN CHECKOUT BUTTON
====================== */
$("#initateCheckout").click(async function (event) {
  event.preventDefault();

  checkBundledVariants();
  checkGroupsellVariants();
  syncAutoBundleToLegacyArray();

  let isLockedBundle = false;

  var groupsellBundleID = Date.now();

  // const isAPPDP = $("#shopify-section-product-template-aura").length > 0;
  // if (isAPPDP) {
  //   await handleAPAddons();
  //   location.href = "/checkout";
  //   return;
  // }

  const isDoors = $("#product-doors-8851863929059").length > 0;
  if (isDoors) {
    await handleDoorsPDP();
    location.href = "/checkout";
    return;
  }

  const isGates = $("#product-gates-8855634280675").length > 0;
  if (isGates) {
    await handleGatesPDP();
    location.href = "/checkout";
    return;
  }

  const isDoorGateBundle = $("#product-door-gate-8890655932643").length > 0;
  if (isDoorGateBundle) {
    try {
      await handleDoorGateBundle();
      location.href = "/checkout";
    } catch (error) {
      console.error(error);
      alert(
        "To complete your order, make sure you’ve included all the required selections before checking out.",
      );
      handleDoorGateBundleError();
    }
    return;
  }

  // check for groupsell
  var Groupsell = $(".selectedgroupsell").text();
  if (
    bundledVariants.length <= 0 &&
    groupsellbundledVariants.length <= 0 &&
    !$(".form-selected #AirconSystemSelect-product-template").length &&
    !$(".selected_variantId").length &&
    !$("#currentSelection").attr("data-variants")
  ) {
    // if ($("#ProdBundle").attr("data-vid")) {
    //   await handlePdpWithAddon();
    //   location.href = "/checkout";
    //   return;
    // }

    window.location.href = $(this).attr("href");
    return;
  }

  var productTitle = $(".product-single__title").text();

  if ($(".zero-aircon-only #AirconSystemSelect-product-template").length) {
    //var selectval = $("#AirconSystemSelect-product-template").val();
    var selectval = $(
      '.form-selected input[name="aircon_select"]:checked',
    ).val();
    if (selectval == "System-1") {
      var variantId = $(
        ".form-selected .ProductSelect-product-template.system-1",
      ).val();
    } else if (selectval == "System-2") {
      var variantId = $(
        ".form-selected .ProductSelect-product-template.system-2",
      ).val();
    } else if (selectval == "System-3") {
      var variantId = $(
        ".form-selected .ProductSelect-product-template.system-3",
      ).val();
    } else if (selectval == "System-4") {
      var variantId = $(
        ".form-selected .ProductSelect-product-template.system-4",
      ).val();
    }
  } else if ($("#currentSelection").length) {
    var variantId = $("#currentSelection").attr("data-variant");
  } else {
    var variantId = $(
      "#ProductSelect-product-template.product-form__variants2",
    ).val();
  }
  if (variantId == "") {
    alert("Please select the system combination.");
    //$(".syscombi").addClass("active");
    //$("#AirconSystem-Display").addClass("empty");
    //$(".AirconSystem-select").toggleClass("active");
    return false;
  }

  var variantTitle = $(
    '.ProductSelect-product-template option[value="' + variantId + '"]',
  ).data("title");
  const option = $(
    '.ProductSelect-product-template option[value="' + variantId + '"]',
  );

  const rawPrice = option.attr("data-price");

  const variantPrice = rawPrice ? rawPrice.replace(/,(?=\d{3})/g, "") : "0";

  var prodQuantity = $("#currentSelection").attr("data-quantity");
  var Groupsell = $(".selectedgroupsell").text();

  // Sentenl and sentry indivual products
  //console.log("sentinel and sentry products");
  if (
    ($("#prism-sentinel-8662946513123").length ||
      $("#prism-sentry-8662946742499").length) &&
    Groupsell != "" &&
    lockBundleVariantsId[variantId + "-" + Groupsell] != undefined
  ) {
    /*
    console.log(
      "lockbundle variants " +
        lockBundleVariantsId[variantId + "-" + Groupsell],
    );*/
    variantId = lockBundleVariantsId[variantId + "-" + Groupsell];
    //console.log("lock bundle id:" + lockBundle[variantId]);
    isLockedBundle = true;
    var bundledVariantIds = lockBundle[variantId].split(",");
    //console.log(bundledVariantIds);
    // Updated bundled variants array
    bundledVariants = [];
    $.each(bundledVariantIds, function (key, val) {
      if (val && val !== "0") bundledVariants.push(val);
    });
    Groupsell = "";
    var productTitle = lockBundleProdudctTitle;
  }

  var itemsToAdd = [];

  let mainProduct = null;

  mainProduct = {
    quantity: prodQuantity,
    id: variantId,
    properties: {},
  };
  itemsToAdd.push(mainProduct);

  const acBundle = $("[name='aircon_bundle_select']:checked");
  if (acBundle.length) {
    mainProduct.properties["_acBundle"] =
      acBundle.val().split("-")[1] || acBundle.val();
  }

  var itemsToAdd = [mainProduct];

  // Pre-order properties
  if ($("#preorderProperty").length) {
    var preorderProperty = $("#preorderProperty").val();
    mainProduct.properties[preorderProperty] = 1;
  }

  // Bundled product
  if (typeof itemsToAdd === "undefined") {
    itemsToAdd = [mainProduct];
  }
  if (bundledVariants.length > 0) {
    //CF instalation sku
    if (
      $("#prism-oasis-pro-8662936355043").length > 0 ||
      $("#prism-oasis-8662929572067").length > 0 ||
      $("#prism-oasis-pro-macaron-8837866651875").length > 0
    ) {
      //bundledVariants.push("45530308247779");
    }
    var bundleId = Date.now();

    mainProduct.properties["Bundle ID"] = bundleId;

    if (note) {
      mainProduct.properties["note"] = note;
    }
    if (ATID) {
      mainProduct.properties["ATID"] = ATID;
    }

    var bundleProduct = {
      quantity: prodQuantity,
      id: null,
      properties: {
        "Bundle ID": bundleId, // for Grouping
        "Bundled with": productTitle, // for identifying bundled product
      },
    };

    $.each(bundledVariants, function (key, val) {
      var product = { ...bundleProduct };
      product.id = val;

      var bundle_data = val.split("-");
      product.id = bundle_data[0];
      if (bundle_data[1]) {
        product.quantity = bundle_data[1];
      }

      itemsToAdd.unshift(product);
    });
  }
  /* ============================
   GROUPSELL-2 BUNDLED CHILDREN
=============================== */
  if (groupsellbundledVariants.length > 0) {
    if (typeof itemsToAdd === "undefined") {
      itemsToAdd = [mainProduct];
    }

    var Groupsell2variantTitle = $("#ProdBundle").attr("data-vtitle") || "";

    groupsellbundledVariants.forEach((val) => {
      let parts = val.split("-");
      let variantId = parts[0];
      let qty = parts[1] ? parseInt(parts[1], 10) : 1;

      itemsToAdd.push({
        id: variantId,
        quantity: qty,
        properties: {
          "Bundle ID": groupsellBundleID,
          "Bundled with": Groupsell2variantTitle,
        },
      });
    });
  }

  /* ============================
   GROUPSELL-2 PARENT PRODUCT
=============================== */
  var Groupsell2variantId = $("#ProdBundle").attr("data-gp2-id");

  if (Groupsell2variantId) {
    if (typeof itemsToAdd === "undefined") {
      itemsToAdd = [mainProduct];
    }

    var Groupsell2variantTitle = $("#ProdBundle").attr("data-vtitle") || "";

    itemsToAdd.push({
      id: Groupsell2variantId,
      quantity: 1,
      properties: {
        "Bundle ID": groupsellBundleID,
        "Bundle Parent": Groupsell2variantTitle,
      },
    });
  }

  /* checkout fix if warranty as second or second groupsell is selected. Issue happens when product has a variant dropdown */
  const secondGroupsell = $(".selectedgroupsell-second").text().trim();

  if ($(".selectedgroupsell").length === 1 && !isLockedBundle) {
    const groupsell_primary = $(".selectedgroupsell").text().trim();

    // Only push if:
    // 1. groupsell_second exists (second groupsell)
    // 2. groupsell_second is NOT the same as primaryGroupsell
    // 3. if it is not locked
    if (groupsell_primary && groupsell_primary !== secondGroupsell) {
      itemsToAdd.push({
        id: groupsell_primary,
        quantity: 1,
        properties: {},
      });
    }
  }
  /* end of groupsell + second groupsell selected fix */

  /* fix if warranty is found, check for groupsell */
  if ($(".selected_variantId").length > 0) {
    const selectedVariantIds = $(".selected_variantId");
    let variantIds = "";
    selectedVariantIds.each((_, x) => {
      const text = $(x).text();
      if (text.trim() != "") {
        variantIds += `,${text}`;
      }
    });
    if (variantIds.trim() != "") {
      variantIds.split(",").forEach((x) => {
        if (x.trim() == "") return;
        if (x.includes("-")) {
          itemsToAdd.push({
            id: x.split("-")[0],
            quantity: x.split("-")[1],
            properties: {},
          });
        } else {
          itemsToAdd.push({
            id: x,
            quantity: 1,
            properties: {},
          });
        }
      });
    }
  }

  /* ============================
    Add Selected Accessories
  ============================= */
  const selectedAddOns = $(".accs-sel-wrapper input:checked");
  if (selectedAddOns.length) {
    selectedAddOns.each(function () {
      const variantId = $(this).val();
      const variantTitle = $(this).attr("data-variant_title") || "";
      const variantPrice = $(this).attr("data-price") || "";

      if (variantId != "") {
        itemsToAdd.push({
          id: variantId,
          quantity: 1,
          properties: {
            "Shopped with": productTitle,
          },
        });
      }
    });
  }

  var contentName = `${productTitle}`;
  if (variantTitle !== "Default Title") contentName += ` - ${variantTitle}`;

  // FB Pixel
  var fbqObj = {
    content_name: contentName,
    content_category: meta.product.type,
    content_ids: [meta.product.id],
    content_type: "product_group",
    value: variantPrice,
    num_items: prodQuantity,
    currency: "SGD",
  };
  if (typeof fbq !== "undefined" && fbq) fbq("track", "AddToCart", fbqObj);
  fbq = null;

  var pri = variantPrice.replace(/\,/g, ""); // 1125, but a string, so convert it to number
  pri = parseInt(pri, 10);

  //TikTok Pixel
  var ttqObj = {
    content_name: contentName,
    content_category: meta.product.type,
    content_id: meta.product.id,
    content_type: "product_group",
    value: pri,
    quantity: prodQuantity,
    currency: "SGD",
  };
  if (ttq) ttq.track("AddToCart", ttqObj);
  if (ttq) ttq.track("InitiateCheckout", ttqObj);

  //console.log(itemsToAdd);

  // switch Sentinel Copper Rose to Sentinel Pro Copper Rose
  const idMap = {
    // Standard
    45530305757411: "48554691854563", // Sentry Space Grey
    45530305855715: "48554691952867", // Sentry Copper Rose
    45530305954019: "48554692051171", // Sentry Nickel Silver
    45530306052323: "48554692149475", // Sentry Pro Space Grey
    45530306150627: "48554692247779", // Sentry Pro Copper Rose
    45530306248931: "48554692346083", // Sentry Pro Nickel Silver
    // Saver
    45775797715171: "48554692444387", // Sentry Space Grey
    45775799648483: "48554692542691", // Sentry Copper Rose
    45775805055203: "48554692640995", // Sentry Nickel Silver
    45775805350115: "48554692739299", // Sentry Pro Space Grey
    45775806464227: "48554692837603", // Sentry Pro Copper Rose
    45775808954595: "48554692935907", // Sentry Pro Nickel Silver
  };
  itemsToAdd = itemsToAdd.map((item) =>
    idMap[item.id] ? { ...item, id: idMap[item.id] } : item,
  );

  // Post to cart
  var params = {
    type: "POST",
    url: "/cart/add.js",
    data: { items: itemsToAdd },
    dataType: "json",
    success: function (line_item) {
      cartTotal();
      window.location.href = "/checkout";
    },
    error: function (XMLHttpRequest, textStatus) {
      //window.location.reload();
      //console.log("Error adding to cart");
      //console.log(XMLHttpRequest);
      //console.log(textStatus);
    },
  };
  $.ajax(params);
});

function cartTotal() {
  jQuery.getJSON("/cart.js", function (cart, textStatus) {
    //the cart info is in the callback. the item_count is available as part of the callback
    //below I set my cartcount div with the current cart item_count
    var carttext = cart.total_price;
    var cartprice = JSON.stringify(carttext);
    //jQuery("div#CartCount .cart-total").text(carttext);
    //var cartext2 = Shopify.formatMoney(carttext, "{{ shop.currency }}");
    var cartpricetext = cartprice
      .substring(0, cartprice.length - 2)
      .toLocaleString()
      .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
    //console.log(cartpricetext);
    jQuery("div#CartCount .cart-total").text("$" + cartpricetext);
  });
}

async function handleAirconBundleOnChange() {
  const cartData = await getCartData();
  const cartHasAircon =
    cartData.items?.some((item) => item.product_id === 8662929015011) || false;

  const voucherElem = $(".voucher-pricing .price-2");

  const input = $('[name="aircon_bundle_select"]');
  input.on("change", function () {
    voucherElem.show();

    const aircon_bundle = this.value;
    const system = getSystem();
    const selOption = getSelectedOption(system);
    const oriPrice = selOption
      .attr("data-price-show")
      ?.replace("$", "")
      .replace(",", "");
    const oriVoucher = selOption.attr("data-voucher");
    let finalVoucherPrice = oriVoucher;

    if (
      (!cartHasAircon && system === "System-2") ||
      (!cartHasAircon && system === "System-1") ||
      system === "System-2" ||
      system === "System-1"
    ) {
      disableStandardBundle();
      //console.log("disable standard");
    } else {
      enableStandardBundle();
      //console.log("WITH ERROR");
    }
    //console.log("my selected option:" + selOption);
    /* IF no voucher but with climate voucher
    if(system === 'System-1'){
      $('.price-2').hide();
      // manually set climate voucher for system 1 since pricing will not be based on off-voucher price 
      setTimeout(function () {
        var mainPrice = $('#ProductPrice-product-template').text();
        console.log('sys1-main:'+mainPrice);
        $('.product-form__cart .voucher1').text(mainPrice);
        myInteger = mainPrice.replace(/\,/g, "").replace('$','');
        var climateValue = 400;
        var useClimateSystem1 = parseInt(myInteger - climateValue);
        $('.climate-voucher-tooltip .voucher-price').text('$'+useClimateSystem1.toLocaleString('en-US'));
      }, 800);
      
    }else{
      $('.price-2').show();
    }
    */
    let oriPrice2 = $("#ProductPrice-product-template")
      .text()
      .replace("$", "")
      .replace(",", "");
    //console.log("loaded price=" + oriPrice2);
    $("#currentSelection").attr("data-price", oriPrice2);
    let voucherPrice = oriPrice2;
    //console.log("oriPrice=" + oriPrice);
    //console.log("mySystem=" + system);
    //console.log("myBundle=" + aircon_bundle);
    if (system === "System-2") {
      if (aircon_bundle == "bundle-saver") {
        finalVoucherPrice = 400;
        voucherPrice -= finalVoucherPrice;
      } else if (aircon_bundle == "bundle-standard") {
        if (cartHasAircon) {
          finalVoucherPrice = 200;
          voucherPrice -= finalVoucherPrice;
        } else {
          voucherElem.hide();
        }
      }
    } else if (system === "System-3") {
      if (aircon_bundle == "bundle-saver") {
        finalVoucherPrice = 800;
        voucherPrice -= finalVoucherPrice;
      } else if (aircon_bundle == "bundle-standard") {
        finalVoucherPrice = 550;
        voucherPrice -= finalVoucherPrice;
      }
    } else if (system === "System-4") {
      if (aircon_bundle == "bundle-saver") {
        //console.log("use saver");
        finalVoucherPrice = 1050;
        voucherPrice -= finalVoucherPrice;
      } else if (aircon_bundle == "bundle-standard") {
        //console.log("use standard");
        finalVoucherPrice = 700;
        voucherPrice -= finalVoucherPrice;
      }
    }
    //console.log("aircon_voucher=" + voucherPrice);
    if (voucherPrice != 0) {
      $("#voucher-price, .voucher1").html(
        theme.Currency.formatMoney(voucherPrice * 100).replace(".00", ""),
      );
      const voucherPrice2 = voucherPrice - window.cv_price;
      $(".voucher-pricing .tooltip .voucher-wrap .voucher-price").html(
        theme.Currency.formatMoney(voucherPrice2 * 100).replace(".00", ""),
      );
      $(
        ".grabpay-box .grabpay-content .flex-item:last-child .price span",
      )?.html(
        theme.Currency.formatMoney(Math.floor(voucherPrice2 / 4) * 100)
          .replace("$", "")
          .replace(".00", ""),
      );

      $("#currentSelection").attr("data-voucher", finalVoucherPrice);
    }
  });

  /**
   * @returns { "System-2" | "System-3" | "System-4" }
   */
  function getSystem() {
    return $('[name="aircon_select"]:checked').val();
  }

  function getSelectedOption(system) {
    const systemSelect = $(`.${system.toLowerCase()}`);
    const value = systemSelect.val();
    return systemSelect.find(`option[value="${value}"]`);
  }

  function disableStandardBundle() {
    //console.log("disabling standard bundle...");

    const bundleStandard = $(
      '[name="aircon_bundle_select"][value="bundle-standard"]',
    );
    bundleStandard.attr("disabled", true);

    const bundleSaver = $(
      '[name="aircon_bundle_select"][value="bundle-saver"]',
    );

    if (!bundleSaver.is(":checked")) {
      //console.log("selecting saver bundle...");
      bundleSaver.prop("checked", true);
      $('[name="aircon_bundle_select"]:checked').trigger("change");
    }
  }

  function enableStandardBundle() {
    //console.log("enabling standard bundle...");

    const bundleStandard = $(
      '[name="aircon_bundle_select"][value="bundle-standard"]',
    );
    bundleStandard.attr("disabled", false);
  }

  if (!cartHasAircon) {
    disableStandardBundle();
  } else {
    $('[name="aircon_bundle_select"]:checked').trigger("change");
  }
}

async function handleAPAddons() {
  let formData = {
    items: [
      {
        id: $("#currentSelection").data("variant"),
        quantity: $("#currentSelection").data("quantity"),
      },
    ],
  };

  // Note: it's either single filter or filter subscription is selected, cannot be both
  const singleFilterWrapper = $(".ap_filter_addon_wrapper .product-wrapper");
  const singleFilterCheckbox = singleFilterWrapper.find(
    "input[type='checkbox']",
  );
  const filterSubWrapper = $(".ap_subscription_addon_wrapper .product-wrapper");
  const filterSubCheckbox = filterSubWrapper.find("input[type='checkbox']");

  if (singleFilterCheckbox.is(":checked")) {
    formData.items.push({
      id: singleFilterWrapper.data("variant_id"),
      quantity: $("#currentSelection").data("quantity"),
    });
  } else if (filterSubCheckbox.is(":checked")) {
    const sellingPlanSelect = filterSubWrapper.find(
      "[name='payment_frequency']",
    );
    const datePicker = filterSubWrapper.find("[name='first_delivery_date']");
    let dateKeyword = sellingPlanSelect.val().includes("periodic")
      ? "First Payment Date"
      : "First Delivery Date";

    formData.items.push({
      id: filterSubWrapper.data("variant_id"),
      selling_plan: sellingPlanSelect
        .find(`option[value="${sellingPlanSelect.val()}"]`)
        .data("selling_plan_id"),
      quantity: $("#currentSelection").data("quantity"),
      properties: {
        [dateKeyword]: datePicker.val(),
      },
    });
  }

  await fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });
}


async function handleDoorsPDP() {
  let bundleId = Date.now();
  const mainProductVariantId = $("#currentSelection").data("variant");

  let formData = {
    items: [
      {
        id: mainProductVariantId,
        quantity: $("#currentSelection").data("quantity"),
        properties: { "Bundle ID": bundleId },
      },
      {
        id: $(".laminate-selector select").val(),
        quantity: $("#currentSelection").data("quantity"),
        properties: {
          "Bundle ID": bundleId,
          "Bundled with": mainProductVariantId,
        },
      },
    ],
  };

  const morticeLockSetVariant = $(
    ".door_mortice_set-selector .item.active",
  ).attr("data-variant");
  if (morticeLockSetVariant != "") {
    formData.items.push({
      id: morticeLockSetVariant,
      quantity: $("#currentSelection").data("quantity"),
      properties: {
        "Bundle ID": bundleId,
        "Bundled with": mainProductVariantId,
      },
    });
  }

  // const peepholeViewerVariant = $(
  //   ".door_peephole_viewer-selector .item.active"
  // ).attr("data-variant");
  // if (peepholeViewerVariant != "") {
  //   formData.items.push({
  //     id: peepholeViewerVariant,
  //     quantity: $("#currentSelection").data("quantity"),
  //     properties: {
  //       "Bundle ID": bundleId,
  //       "Bundled with": mainProductVariantId,
  //     },
  //   });
  // }

  const doorCloserVariant = $(".door_closer-selector .item.active").attr(
    "data-variant",
  );
  if (doorCloserVariant != "") {
    formData.items.push({
      id: doorCloserVariant,
      quantity: $("#currentSelection").data("quantity"),
      properties: {
        "Bundle ID": bundleId,
        "Bundled with": mainProductVariantId,
      },
    });
  }

  const locks = $(".groupsell-wrap-second input:checked");
  if (locks.length) {
    formData.items.push({
      id: locks.val(),
      quantity: $("#currentSelection").data("quantity"),
    });
  }

  const warranty = $(
    ".addon_by_variants-container .addon:not(.hide) input:checked",
  );
  if (warranty.length) {
    formData.items.push({
      id: warranty.val(),
      quantity: $("#currentSelection").data("quantity"),
    });
  }

  const addonVariant = $("#ProdBundle").attr("data-gp2-id");

  if (addonVariant) {
    formData.items.push({
      id: addonVariant,
      quantity: $("#currentSelection").data("quantity"),
      properties: {},
    });
  }

  await fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });
}

async function handleGatesPDP() {
  let bundleId = Date.now();
  const mainProductVariantId = Number(
    $(".gate-selector select:not(.hide)").val(),
  );

  let formData = {
    items: [
      {
        id: mainProductVariantId,
        quantity: 1,
        properties: { "Bundle ID": bundleId },
      },
    ],
  };

  const laminateSelector = $(
    ".gate-selector:not(.hide)[data-option='laminate']",
  );
  if (laminateSelector.length) {
    formData.items.push({
      id: laminateSelector.find("select").val(),
      quantity: 1,
      properties: {
        "Bundle ID": bundleId,
        "Bundled with": mainProductVariantId,
      },
    });
  }

  const addOnSelectors = $("[data-option^='gate-']");
  addOnSelectors.each(function () {
    const option = $(this).attr("data-option");
    if (option == "gate-colours") {
      formData.items[0].properties["Colours"] = $(this)
        .find(".item.active")
        .attr("data-title");
    }

    const variantId = $(this).find(".item.active").attr("data-variant");
    if (variantId != "") {
      formData.items.push({
        id: variantId,
        quantity: 1,
        properties: {
          "Bundle ID": bundleId,
          "Bundled with": mainProductVariantId,
        },
      });
    }
  });

  const selectedgroupsell = $("selectedgroupsell").text();
  if (selectedgroupsell != "") {
    formData.items.push({
      id: selectedgroupsell,
      quantity: $("#currentSelection").data("quantity"),
    });
  }

  const locks = $(".groupsell-wrap-second input:checked");
  if (locks.length) {
    formData.items.push({
      id: locks.val(),
      quantity: $("#currentSelection").data("quantity"),
    });
  }

  const warranty = $(
    ".addon_by_variants-container .addon:not(.hide) input:checked",
  );
  if (warranty.length) {
    formData.items.push({
      id: warranty.val(),
      quantity: $("#currentSelection").data("quantity"),
    });
  }

  const addonVariant = $("#ProdBundle").attr("data-gp2-id");

  if (addonVariant) {
    formData.items.push({
      id: addonVariant,
      quantity: $("#currentSelection").data("quantity"),
      properties: {},
    });
  }

  await fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });
}

async function handleDoorGateBundle() {
  const bundleId = Date.now();
  const quantity = 1;
  let formData = { items: [] };

  const productType = $("[data-option='product_type'] .item.active").attr(
    "data-product_type",
  );
  switch (productType) {
    case "bundle":
      handleDoor();
      handleGate();
      break;
    case "door":
      handleDoor();
      break;
    case "gate":
      handleGate();
      break;
  }

  handleLock();
  handleLockWarranty();

  function handleDoor() {
    const door_variantId = $("[data-option='door-size'] .item.active").attr(
      "data-variant",
    );
    const bundleProperties = {
      "Bundle ID": bundleId,
      "Bundled with": door_variantId,
    };
    formData.items.push(
      {
        id: door_variantId,
        quantity: quantity,
        properties: { "Bundle ID": bundleId },
      },
      {
        id: $("[data-option='door-laminate'] select").val(),
        quantity: quantity,
        properties: bundleProperties,
      },
      {
        id: $("[data-option='door-mortice_lock_set'] .item.active").attr(
          "data-variant",
        ),
        quantity: quantity,
        properties: bundleProperties,
      },
      {
        id: $("[data-option='door-closer'] .item.active").attr("data-variant"),
        quantity: quantity,
        properties: bundleProperties,
      },
    );
  }

  function handleGate() {
    const gate_variantId = $(
      "[data-option='gate-design'] select:not(.hide)",
    ).val();
    const bundleProperties = {
      "Bundle ID": bundleId,
      "Bundled with": gate_variantId,
    };
    formData.items.push(
      {
        id: gate_variantId,
        quantity: quantity,
        properties: {
          "Bundle ID": bundleId,
          Colours: $("[data-option='gate-colours'] .item.active").attr(
            "data-title",
          ),
        },
      },
      {
        id: $("[data-option='gate-colours'] .item.active").attr("data-variant"),
        quantity: quantity,
        properties: bundleProperties,
      },
      {
        id: $("[data-option='gate-mortice_lock_set'] .item.active").attr(
          "data-variant",
        ),
        quantity: quantity,
        properties: bundleProperties,
      },
      {
        id: $("[data-option='gate-unit_number'] .item.active").attr(
          "data-variant",
        ),
        quantity: quantity,
        properties: bundleProperties,
      },
    );

    const gatePlate = $("[data-option='gate-plate'] .item.active").attr(
      "data-variant",
    );
    if (gatePlate) {
      formData.items.push({
        id: gatePlate,
        quantity: quantity,
        properties: bundleProperties,
      });
    }

    const gateLaminate = $(
      "[data-option='gate-laminate']:not(.hide) select",
    ).val();
    if (gateLaminate) {
      formData.items.push({
        id: gateLaminate,
        quantity: quantity,
      });
    }
  }

  function handleLock() {
    const lockType = $("[data-option='locks-type'] .item.active").attr(
      "data-lock_type",
    );
    switch (lockType) {
      case "bundle":
        const bundleType =
          $("[data-option='locks-bundle-type'] .item.active").attr(
            "data-lock_bundle_type",
          ) == "standard"
            ? ""
            : "-saver";
        //console.log("quidckfix" + lockType);
        const doorLock_model = $(
          "[data-option='door-lock-model'] .item.active",
        ).attr("data-lock_model");
        const doorLock_features = $(
          "[data-option='door-lock-features'] .item.active",
        ).attr("data-lock_features");
        const doorLock_colour = $(
          "[data-option='door-lock-colour'] .item.active",
        ).attr("data-lock_colour");
        const gateLock_model = $(
          "[data-option='gate-lock-model'] .item.active",
        ).attr("data-lock_model");
          const gateLock_features = $(
            "[data-option='gate-lock-features'] .item.active",
          ).attr("data-lock_features");
        const gateLock_colour = $(
          "[data-option='gate-lock-colour'] .item.active",
        ).attr("data-lock_colour");
        let bundle_handle = `${doorLock_model}${doorLock_features == "ultra" ? "-ultra" : ""}-door-lock-${doorLock_colour}-${gateLock_model}${gateLock_features == "ultra" ? "-ultra" : ""}-gate-lock-${gateLock_colour}`;
        bundle_handle = bundle_handle.replace(
          "-privacy-ultra-",
          "-ultra-privacy-",
        );
        const lockBundleItem = $(`[data-handle='${bundle_handle}']`);
        if (lockBundleItem.length) {
          formData.items.push({
            id: lockBundleItem.attr("data-variant"),
            quantity: quantity,
            properties: { "Bundle ID": bundleId },
          });

          const bundledVariants = lockBundleItem.attr("data-bundled_variants");
          if (bundledVariants) {
            bundledVariants.split(",").forEach((variantId) => {
              formData.items.push({
                id: variantId,
                quantity: quantity,
                properties: {
                  "Bundle ID": bundleId,
                  "Bundled with": lockBundleItem.attr("data-variant"),
                },
              });
            });
          }
        }
        break;
      case "door_lock":
        formData.items.push({
          id: $("[data-option='door-lock-colour'] .item.active").attr(
            "data-variant",
          ),
          quantity: quantity,
        });
        break;
      case "gate_lock":
        formData.items.push({
          id: $("[data-option='gate-lock-colour'] .item.active").attr(
            "data-variant",
          ),
          quantity: quantity,
        });
        break;
    }
  }

  function handleLockWarranty() {
    // Active period option carries data-variants: one id for a single lock,
    // two ids (door EW + gate EW) for a bundle. Add them all.
    const active = $(
      ".custom_accordion[data-product_type='locks-warranty-addon']:not(.hide) [data-option='locks-warranty'] .item.active",
    );
    const variantIds = (active.attr("data-variants") || "")
      .split(",")
      .filter(Boolean);
    variantIds.forEach((id) => {
      formData.items.push({
        id: id,
        quantity: quantity,
      });
    });
  }

  // console.log(formData);

  const response = await fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });

  if (!response.ok) {
    console.error(response);
    throw new Error("Response not ok.");
  }

  //console.log(response);
}

function handleDoorGateBundleError() {
  $(".error_msg").addClass("hide");
  const selectors = $(".door-gate-bundle-selector");
  selectors.each(function () {
    if ($(this).find(".item").length) {
      if (!$(this).find(".item.active").length) {
        $(this).find(".error_msg").removeClass("hide");
      }
    }
  });

  const accordions = $(".custom_accordion.open");
  accordions.each(function () {
    const accordionBody = $(this).find(".accordion_body");
    const group = accordionBody.find(".product-group-variants");
    const height = group[0].scrollHeight;
    accordionBody.css("height", `${height}px`);
  });

  // scroll to the first section with error message
  $(
    $(
      ".custom_accordion:not(.hide) .door-gate-bundle-selector:not(.hide):has(.error_msg:not(.hide))",
    )[0],
  )
    .closest(".custom_accordion:not(.hide, .open)")
    .find(".accordion_header")
    .click();
  window.scrollTo(
    0,
    $(
      ".custom_accordion:not(.hide) .door-gate-bundle-selector:not(.hide):has(.error_msg:not(.hide))",
    )[0].getBoundingClientRect().top +
      window.pageYOffset -
      $("#shopify-section-header")[0].clientHeight,
  );
}

async function handlePdpWithAddon() {
  const mainVariant = $("#currentSelection").attr("data-variant");
  const addonVariant = $("#ProdBundle").attr("data-vid");

  let formData = {
    items: [
      {
        id: mainVariant,
        quantity: 1,
      },
      {
        id: addonVariant,
        quantity: 1,
        properties: {
          _addon_type: $("#ProdBundle").attr("data-vtype"),
        },
      },
    ],
  };

  await fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });
}
